import * as React from 'react';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { PATIENT_LIST_VIEW } from 'pages/Dashboard/enums';
import SelectProvider from 'pages/Dashboard/components/SelectProvider';
import { PracticeProvider } from 'pages/Dashboard/types/providers.types';
import Theme from 'theme';
import SearchBar from 'pages/Dashboard/components/SearchBar';

interface TProps {
  statusFilter: string;
  patientsCount: Record<string, number>;
  updateStatusFilter: React.Dispatch<string>;
  isFetching: boolean;
  providerAssociations: PracticeProvider[];
  providerIdFilter: string;
  setProviderIdFilter: (provider: string) => void;
  debouncedSearchQuery: (query: string) => void;
}

export default function ListPatientFilters({
  statusFilter,
  patientsCount,
  updateStatusFilter,
  isFetching,
  providerAssociations,
  providerIdFilter,
  setProviderIdFilter,
  debouncedSearchQuery,
}: TProps) {
  const titleMap = {
    READY: 'ACTIVATED',
    PENDING: 'PENDING SIGN UP',
  };

  return (
    <>
      <Box
        gap={{ md: 7, xs: 3 }}
        mb={1.5}
        display='flex'
        flexDirection='row'
        justifyContent='space-between'
        alignItems='center'
        flexWrap='wrap'
      >
        <Box sx={{ display: 'flex', gap: 0 }}>
          {Object.values(PATIENT_LIST_VIEW).map((filter) => (
            <Box key={filter}>
              <Typography
                fontSize={14}
                fontStyle='small'
                sx={{
                  borderBottom: 3,
                  paddingBottom: 1,
                  pl: 2,
                  pr: 2,
                  borderBottomColor: statusFilter === filter ? Theme.custom.darkTextPrimary : 'transparent',
                  cursor: 'pointer',
                  color:
                    statusFilter === filter
                      ? Theme.custom.darkTextPrimary
                      : Theme.custom.colors.lightTextSecondary,
                  fontWeight: 500,
                  whiteSpace: 'nowrap',
                }}
                onClick={() => updateStatusFilter(filter)}
              >
                {`${titleMap[filter]} (${patientsCount[filter] || 0})`}
              </Typography>
            </Box>
          ))}
        </Box>
        <Box flex={1} minWidth={200} maxWidth={600}>
          <SearchBar onSearch={debouncedSearchQuery} />
        </Box>
        {providerAssociations.length > 0 && (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <SelectProvider
            providers={providerAssociations}
            selectedProvider={providerIdFilter}
            setSelectedProvider={setProviderIdFilter}
          />
        </Box>
        )}
      </Box>

      <Grid container spacing={1} />
    </>
  );
}
